import { Component } from '@angular/core';

@Component({
  selector: 'app-call-support-action-button',
  templateUrl: './call-support-action-button.component.html',
  styleUrls: ['./call-support-action-button.component.scss'],
  standalone: false,
})
export class CallSupportActionButtonComponent {
  isOpen = false;
  isFabVisible = true;

  showSupportPhoneNumPopup() {
    setTimeout(() => {
      this.isOpen = true;
    }, 20);
  }
  onClickedOutside(event: Event) {
    if (this.isOpen) this.isOpen = false;
  }

  ngOnInit() {
    window.addEventListener('scroll', (event) => {
      if (window.scrollY > 100) {
        this.isFabVisible = false;
        this.isOpen = false;
      } else {
        this.isFabVisible = true;
      }
    });
  }
}
